<!--
(C) Copyright 2015–2022 Potsdam Institute for Climate Impact Research (PIK), authors, and contributors, see AUTHORS file.

This file is part of vodle.

vodle is free software: you can redistribute it and/or modify it under the
terms of the GNU Affero General Public License as published by the Free
Software Foundation, either version 3 of the License, or (at your option)
any later version.

vodle is distributed in the hope that it will be useful, but WITHOUT ANY
WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
details.

You should have received a copy of the GNU Affero General Public License
along with vodle. If not, see <https://www.gnu.org/licenses/>.
-->

<ion-app>
  <ion-split-pane contentId="main">
    <ion-menu contentId="main" data-vodle="navigation-menu">
      <ion-header>
        <ion-toolbar>
          <ion-title>
            <a href="http://www.vodle.it"><img src="./assets/topleft_icon.svg" height="40px" alt="vodle"></a>
          </ion-title>
        </ion-toolbar>
      </ion-header>
      <ion-content>
        <ion-list data-vodle="navigation-list">
          @for (p of appPages; track p) {
            <ion-menu-toggle auto-hide="false">
              <ion-item [routerDirection]="'root'" [routerLink]="[p.url]" [attr.data-vodle]="'nav-item-' + p.url.replace('/', '')">
                <ion-icon slot="start" [name]="p.icon"></ion-icon>
                <ion-label>
                  {{p.title|translate}}
                </ion-label>
              </ion-item>
            </ion-menu-toggle>
          }
        </ion-list>
      </ion-content>
    </ion-menu>
    <ion-router-outlet id="main"></ion-router-outlet>
  </ion-split-pane>
</ion-app>
